import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-290bfdaf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-box" }

import {CrudFormService} from "@/components/business/crud/service/CrudFormService";
import WidgetForm from "@/components/business/crud/form/WidgetForm.vue";
import {useQueryParam} from "@/util/queryParam";
import {watch} from "vue";
import {useRoute} from "vue-router";
import {app} from "@/models/App";


export default /*#__PURE__*/_defineComponent({
  __name: 'CrudForm',
  props: {
    moduleName: {},
    controllerName: {},
    scene: {}
  },
  setup(__props: any) {

const props = __props;
// id为主键
const schema = app.data.widgetMap[props.moduleName][props.controllerName];
const route = useRoute();
const primary = route.query[schema.primary]
const queryParam = useQueryParam("readonlyFields");
const service = CrudFormService.create(
    props.moduleName,
    props.controllerName,
    {
      primary: typeof primary === "string" ? primary : undefined,
      status: props.scene === "view" ? "show" : "edit",
    }
)
service.init().then(() => {
  watch(() => queryParam.value, () => {
    service.setReadonlyFields(queryParam.value)
  }, {immediate: true})
})
const {title, form, groups, submit, canToggle, toggle, status} = service.use();


return (_ctx: any,_cache: any) => {
  const _component_sc_page = _resolveComponent("sc-page")!

  return (_openBlock(), _createBlock(_component_sc_page, {
    title: _unref(title),
    loading: !_unref(form).ready.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(WidgetForm, {
          status: _unref(status),
          "can-toggle": _unref(canToggle),
          form: _unref(form),
          groups: _unref(groups),
          toggle: _unref(toggle),
          onSubmit: _unref(submit)
        }, null, 8, ["status", "can-toggle", "form", "groups", "toggle", "onSubmit"])
      ])
    ]),
    _: 1
  }, 8, ["title", "loading"]))
}
}

})